<template>
  <Modal
    :is-open="isOpen"
    icon="tags"
    :title="$t('ui.common.tag', 2)"
    description="Tags are used to quickly identify key customer information."
    :buttons="[]"
    close-text="Close"
    min-width="500"
    overflow-behaviour="visible"
    @close-modal="$emit('close')"
  >
    <Select
      :model-value="selectedTagIDs"
      :options="allTagsList"
      mode="multiple"
      chips
      :can-remove-chips="true"
      value-key="id"
      label-key="title"
      searchable
      @select="$emit('add-tag', $event)"
      @deselect="$emit('remove-tag', $event)"
    />
  </Modal>
</template>

<script setup lang="ts">
// components
import Modal from '@/components/modal/Modal.vue'
import Select from '@/components/forms/Select.vue'

interface Tag {
  id: number
  title: string
  displayStyle?: string
}

interface Props {
  isOpen: boolean
  selectedTagIDs: number[]
  allTagsList: Tag[]
}

defineProps<Props>()

defineEmits<{
  close: []
  'add-tag': [tagID: number]
  'remove-tag': [tagID: number]
}>()
</script>
